// Ouste Cart Drawer v2
var OusteCart=(function(){
'use strict';
var isOpen=false;

function fmt(cents){
  return(cents/100).toLocaleString('fr-FR',{minimumFractionDigits:2,maximumFractionDigits:2})+' €';
}

function fetchCart(cb){
  fetch('/cart.js').then(function(r){return r.json();}).then(function(c){if(cb)cb(c);}).catch(function(e){console.error(e);});
}

function addItems(items,cb){
  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
    body:JSON.stringify({items:items})
  }).then(function(r){return r.json();}).then(function(){if(cb)cb();}).catch(function(e){console.error(e);});
}

function changeItem(key,qty,cb){
  fetch('/cart/change.js',{
    method:'POST',
    headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
    body:JSON.stringify({id:key,quantity:qty})
  }).then(function(r){return r.json();}).then(function(c){if(cb)cb(c);}).catch(function(e){console.error(e);});
}

function renderLine(item){
  var img=item.image?('<img src="'+item.image+'" alt="'+item.product_title+'" loading="lazy">'):('<div class="oc-item-no-img"></div>');
  var variant=item.variant_title&&item.variant_title!=='Default Title'?('<div class="oc-variant">'+item.variant_title+'</div>'):""; 
  return '<div class="oc-item" data-key="'+item.key+'">'+
    '<div class="oc-item-img">'+img+'</div>'+
    '<div class="oc-item-info">'+
      '<div class="oc-item-title">'+item.product_title+'</div>'+
      variant+
      '<div class="oc-item-price">'+fmt(item.final_line_price)+'</div>'+
    '</div>'+
    '<div class="oc-item-ctrl">'+
      '<button class="oc-qty" data-key="'+item.key+'" data-delta="-1">&minus;</button>'+
      '<span>'+item.quantity+'</span>'+
      '<button class="oc-qty" data-key="'+item.key+'" data-delta="1">+</button>'+
    '</div>'+
  '</div>';
}

function renderCart(cart){
  var el=document.getElementById('oc-items');
  var totalEl=document.getElementById('oc-total');
  var emptyEl=document.getElementById('oc-empty');
  var footerEl=document.getElementById('oc-footer');
  if(!el)return;
  if(!cart.items||cart.items.length===0){
    el.innerHTML='';
    if(emptyEl)emptyEl.style.display='';
    if(footerEl)footerEl.style.display='none';
  }else{
    if(emptyEl)emptyEl.style.display='none';
    if(footerEl)footerEl.style.display='';
    el.innerHTML=cart.items.map(renderLine).join('');
    el.querySelectorAll('.oc-qty').forEach(function(btn){
      btn.addEventListener('click',function(){
        var key=btn.dataset.key;
        var item=cart.items.find(function(i){return i.key===key;});
        var newQty=Math.max(0,(item?item.quantity:1)+parseInt(btn.dataset.delta));
        changeItem(key,newQty,function(c){
          cart=c;
          renderCart(c);
          updateCount(c);
        });
      });
    });
  }
  if(totalEl)totalEl.textContent=fmt(cart.total_price);
  var upsellEl=document.getElementById('oc-upsell');
  if(upsellEl)upsellEl.style.display=(cart.items&&cart.items.length>0)?'':'none';
  updateCount(cart);
}

function updateCount(cart){
  var n=cart.item_count||0;
  document.querySelectorAll('.cart-count').forEach(function(el){
    el.textContent=n;
    el.style.display=n>0?'':'none';
  });
  var hc=document.getElementById('oc-header-count');
  if(hc)hc.textContent=n;
  var sc=document.getElementById('ouste-sticky-cart');
  var scBadge=document.getElementById('oc-sticky-badge');
  var scCount=document.getElementById('oc-sticky-count');
  var scPrice=document.getElementById('oc-sticky-price');
  if(sc){
    if(n>0){
      sc.removeAttribute('hidden');
      sc.classList.add('sc-show');
      if(scBadge)scBadge.textContent=n;
      if(scCount)scCount.textContent=n+(n>1?' articles':' article');
      if(scPrice)scPrice.textContent=fmt(cart.total_price);
    }else{
      sc.setAttribute('hidden','');
      sc.classList.remove('sc-show');
    }
  }
}

function open(){
  fetchCart(function(c){
    renderCart(c);
    var d=document.getElementById('ouste-cart-drawer');
    var ov=document.getElementById('ouste-cart-ov');
    if(d){d.classList.add('oc--open');d.removeAttribute('aria-hidden');}
    if(ov){ov.classList.add('show');}
    document.body.style.overflow='hidden';
    isOpen=true;
  });
}

function close(){
  var d=document.getElementById('ouste-cart-drawer');
  var ov=document.getElementById('ouste-cart-ov');
  if(d){d.classList.remove('oc--open');d.setAttribute('aria-hidden','true');}
  if(ov){ov.classList.remove('show');}
  document.body.style.overflow='';
  isOpen=false;
}

function init(){
  var closeBtn=document.getElementById('oc-close');
  if(closeBtn)closeBtn.addEventListener('click',close);
  var ov=document.getElementById('ouste-cart-ov');
  if(ov)ov.addEventListener('click',close);
  document.querySelectorAll('[data-cart-trigger]').forEach(function(btn){
    btn.addEventListener('click',function(e){e.preventDefault();open();});
  });
  var stickyBtn=document.getElementById('oc-sticky-btn');
  if(stickyBtn)stickyBtn.addEventListener('click',open);

  var pdpForm=document.querySelector('[data-pdp-form]');
  if(pdpForm){
    pdpForm.addEventListener('submit',function(e){
      e.preventDefault();
      var vid=parseInt(document.getElementById('pdp-variant-id').value);
      var qty=parseInt(document.getElementById('qVal').value)||1;
      var items=[{id:vid,quantity:qty}];
      var addonChk=document.getElementById('addon-chk');
      if(addonChk&&addonChk.checked){
        var aId=parseInt(addonChk.dataset.variantId);
        if(aId)items.push({id:aId,quantity:1});
      }
      var addBtn=document.getElementById('pdp-add');
      if(addBtn){addBtn.disabled=true;addBtn.textContent='...';}
      addItems(items,function(){
        if(addBtn){
          addBtn.disabled=false;
          addBtn.innerHTML='Ajouté ✓';
          setTimeout(function(){
            try{
              var pEl=document.getElementById('pdp-btn-price');
              if(pEl)addBtn.innerHTML='Ajouter au panier · <span id="pdp-btn-price">'+pEl.textContent+'</span>';
            }catch(ex){}
            addBtn.disabled=false;
          },2000);
        }
        open();
      });
    });
  }

  document.querySelectorAll('.ups-add,.oc-bs-add,.oc-ea-add').forEach(function(btn){
    btn.addEventListener('click',function(){
      var vid=parseInt(btn.dataset.variantId);
      if(!vid)return;
      btn.disabled=true;btn.textContent='...';
      addItems([{id:vid,quantity:1}],function(){
        btn.textContent='✓ Ajouté';btn.classList.add('added');
        fetchCart(function(c){updateCount(c);renderCart(c);});
        setTimeout(function(){btn.disabled=false;btn.textContent='+ Ajouter';btn.classList.remove('added');},2500);
      });
    });
  });

  // Initial render
  fetchCart(function(c){renderCart(c);});
}

document.addEventListener('DOMContentLoaded',init);

return{open:open,close:close,addItems:addItems,fetchCart:fetchCart};
})();
